// extracted by mini-css-extract-plugin
export default {"candidatesList":"candidatesList__FIn3m","buttonWrapper":"buttonWrapper__++m9a","buttonList":"buttonList__KdK4q"};